<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{ headingText }}</h4>
  <div *ngIf="!loading; else loader">
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> Ricerca </mat-panel-title>
          <mat-panel-description>
            Ricerca avanzata utenti
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ricerca-utenti [(search)]="search"></ricerca-utenti>
      </mat-expansion-panel>
    </mat-accordion>
    <div *ngIf="visiblePreferenceHints?.length" class="preference-hints">
      <ul class="preference-hints__list">
        <li *ngFor="let hint of visiblePreferenceHints">
          <button
            type="button"
            class="preference-hints__chip"
            [disabled]="!selectionMode"
            (click)="selectPreferenceHint(hint)"
          >
            {{ hint.label }}
          </button>
        </li>
      </ul>
    </div>

    <resourceful-index
      #index
      [search]="search"
      [modelService]="userService"
      [deleteFunction]="deleteFunction"
      [columnDefinitions]="columnDefinitions"
      [editFunction]="canEditUsers ? editFunction : null"
      [selectionMode]="selectionMode"
      (selectedModel)="closeDialogWithSelectedModel($event)"
      [relations]="relations"
      [rowClassGetter]="rowClassGetter"
      (newModelsLoaded)="updateVisiblePreferenceHints()"
      [overrideResults]="allStudios"
      [overrideFunction]="allStudios ? allStudiosOverrideFunction : null"
    >
    </resourceful-index>

    <button mat-raised-button color="primary" class="mt-4" (click)="add()">
      Aggiungi un utente<mat-icon>add</mat-icon>
    </button>
  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
